import { Component } from 'react';
import { assoc } from 'ramda';
import { PublishView } from '../../components';
import readyAnimation from '../../ext/publish-animations/ready.json';
import publishAnimation from '../../ext/publish-animations/publish.json';
import s from './HostStyles.module.scss';

const initialState = {
    animationOptions: {
        loop: true,
        autoplay: true,
        animationData: readyAnimation,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
    },
    banner: {
        icon: '',
        message: '',
        isVisible: false,
    },
    publishPending: false,
    startDate: new Date(),
    status: '',
    stopDate: new Date(),
};

export default class PublishViewHost extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }

    publishVenue = animationOptions => {
        this.setState({
            status: 'RUNNING',
            publishPending: true,
            banner: {
                icon: 'icon-fluidloader',
                message: 'Update has been received and will be published shortly. You can close this tab at anytime.',
                isVisible: true,
                color: 'blue',
            },
            animationOptions: assoc('animationData', publishAnimation, animationOptions),
        });
    };

    render() {
        const { animationOptions, banner, publishPending, startDate, status, stopDate } = this.state;

        return (
            <div className={s.editor} style={{ padding: '80px' }}>
                <PublishView
                    animationOptions={animationOptions}
                    banner={banner}
                    publishPending={publishPending}
                    publishVenue={() => this.publishVenue(animationOptions)}
                    startDate={startDate}
                    status={status}
                    stopDate={stopDate}
                />
                <button type="button" onClick={() => this.setState(initialState)} className={s.resetButton}>
                    Reset
                </button>
            </div>
        );
    }
}
